import PerfectScrollbar from "react-perfect-scrollbar";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import { find } from "../../utilities";
import { CardSkeleton } from "../../Shared/Skeletons/CardSkeleton";
import GridCard from "./Cards/GridCard";
import "./Styles/IndexPageGrid.scss";
import CampaignHeader from "../Video/Components/Campaign/CampaignHeader";

const IndexPageGrid = ({
  cardType,
  handleOpenSinglePublish,
  handleVideoCard,
  notes,
  handleProductCard,
}) => {
  const products = useSelector((state) => state.products);
  const videos = useSelector((state) => state.videos);
  const productData = useSelector((state) => state.productData);
  const videoData = useSelector((state) => state.videoData);

  const getActiveData = {
    Product: productData,
    Video: videoData,
  };

  const getActiveItem = {
    Product: products,
    Video: videos,
  };

  const loadSkeletons = () => {
    const rows = [];
    for (let i = 0; i < 6; i++) {
      rows.push(<CardSkeleton key={uuidv4()} />);
    }
    return rows;
  };

  const conditionalProps = (item) => {
    const propsObj = {};
    if (cardType === "Video") {
      propsObj.videoProducts = item.products;
      propsObj.note = find(notes, item?.video?._id, "video_id");
      propsObj.handleOpenSinglePublish = handleOpenSinglePublish(
        item && item.video._id
      );
      propsObj.handleLinkClick = handleVideoCard(item.video);
    }
    if (cardType === "Product") {
      propsObj.handleLinkClick = handleProductCard(item);
    }
    return propsObj;
  };

  const renderCard = () =>
    getActiveItem[cardType].map((item) => (
      <GridCard
        key={uuidv4()}
        item={item}
        cardType={cardType}
        {...conditionalProps(item)}
      />
    ));

  return (
    <div className="IndexPageGrid">
      <PerfectScrollbar
        className="main-menu-content ps-3 pe-3 scroll-container"
        options={{ wheelPropagation: true }}
      >
        <div className="grid-container">
          {getActiveData[cardType].loading ? loadSkeletons() : renderCard()}
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default IndexPageGrid;
